import {isFunction} from 'lodash';
import {PureComponent} from 'react';

type Props = {
    readonly startDate?: Date;
    readonly startDateNow?: boolean;
    readonly endDate: Date;
    readonly className?: string;
    readonly config?: {
        hours?: boolean;
        minutes?: boolean;
        seconds?: boolean;
        optionalHours?: boolean;
    }
    readonly timeOverDiff: number;
    readonly children?: (data: {time: string | null}) => React.ReactNode;
    readonly onDiffChange: (value: number) => void;
    readonly onTimeOver: () => void;
}

const defaultProps: Partial<Props> = {
    config: {
        hours: true,
        minutes: true,
        seconds: true,
        optionalHours: true
    }
};

type State = {
    readonly currentDate: Date | null
}

const initialState: State = {
    currentDate: null,
};

export default class Timer extends PureComponent<Props, State> {

    readonly state = initialState;
    static readonly defaultProps = defaultProps;

    timer = -1;

    componentDidMount() {
        this.setState({currentDate: this.getCurrentDate()});

        this.timer = window.setInterval(() => {
            const currentDate = this.getCurrentDate();
            this.setState({currentDate});

            if (this.props.onDiffChange || this.props.onTimeOver) {
                const diff = this.getDiff(currentDate);
                this.props.onDiffChange?.(diff);
                if (diff <= (this.props.timeOverDiff || 0)) {
                    this.props.onTimeOver?.();
                }
            }
        }, 1000);
    }

    componentWillUnmount() {
        const {timer} = this;
        if (this) {
            clearInterval(timer);
        }
    }

    getDiff = (currentDate = this.state.currentDate) => {
        const {startDate, endDate, startDateNow} = this.props;
        return +new Date(endDate || currentDate) - (startDateNow ? +new Date() : +new Date(startDate));
    };

    getCurrentDate = () => new Date();

    toHHMMSS = (milliseconds: number): string => {
        const {config} = this.props;
        const sec_num = milliseconds / 1000;

        let hours: number | string = Math.floor(sec_num / 3600);
        let minutes: number | string = Math.floor((sec_num - (hours * 3600)) / 60);
        let seconds: number | string = Math.floor(sec_num - (hours * 3600) - (minutes * 60));

        if (hours < 10) {
            hours = '0' + hours;
        }
        if (minutes < 10) {
            minutes = '0' + minutes;
        }
        if (seconds < 10) {
            seconds = '0' + seconds;
        }
        const values = [];
        if (config.hours || (config.optionalHours && +hours > 0)) {
            values.push(hours);
        }
        if (config.minutes) {
            values.push(minutes);
        }
        if (config.seconds) {
            values.push(seconds);
        }
        return values.join(':');
    };

    render() {
        const {toHHMMSS, getDiff, props: {children, className}, state: {currentDate}} = this;

        if (!currentDate) {
            return null;
        }

        const time = toHHMMSS(getDiff());
        return (
            isFunction(children) ? children({time}) : <span className={className}>{time}</span>
        );
    }
}
